export default __webpack_public_path__ + "static/loading-bf36edf670a028c2e9b4abcf3eeebedc.gif";